import { css } from '@emotion/react';
import reset from 'emotion-reset';

const globalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;600;700;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Titan+One&display=swap');

  @font-face {
    font-family: 'KoPub';
    src: url('/fonts/KoPubDotumLight.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'KoPub';
    src: url('/fonts/KoPubDotumMedium.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'KoPub';
    src: url('/fonts/KoPubDotumBold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  ${reset}

  :root {
    --bg-color: #4d5ced;
    --hover: #f5c1c1;
    --button-bg-color: #5768fc;
    --slogun-shadow-color: #f56264;
    --bronze-color: #f5c1c1;
    --silver-color: #7f89cd;
    --gold-color: #ffbb00;
  }

  body {
    font-family: 'Noto Sans', 'KoPub', Arial, Helvetica, sans-serif;
    height: 100%;
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export default globalStyles;
